import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { LoaderComponent } from './loader/loader.component';
import { ModalService } from '@app/shared/modal.service';
import { AlertComponent } from '@app/shared/components/alert/alert.component';
import { RouterModule } from '@angular/router';
import { BtnLoaderComponent } from '@app/shared/loader/btn-loader.component';
import { AlertModalComponent } from '@app/shared/modals/alert-modal.component';
import { FileUploaderComponent } from '@app/shared/components/file-uploader.component';
import { FairnessModalComponent } from '@app/shared/modals/fairness-modal.component';
import { TermsandconditionsModalComponent } from '@app/shared/modals/termsandconditions-modal.component';
import { ReactiveFormsModule } from '@angular/forms';
import { BalanceIndicatorComponent } from '@app/shared/components/balance-indicator.component';
import { TranslateModule } from '@ngx-translate/core';
import { I18nService } from '@app/core/i18n.service';
import { ReplyDiceComponent } from '@app/shared/components/reply/reply-dice.component';
import { ReplyBlackjackComponent } from '@app/shared/components/reply/reply-blackjack.component';
import { GuestModalTimedComponent } from '@app/shared/modals/guest-modal-timed.component';
import { ClipboardModule } from 'ngx-clipboard';
import { InfiniteScrollDirective } from '@app/shared/directives/infinity-scroll.directive';
import { UserAvatarComponent } from '@app/shared/components/user-avatar.component';
import { FilterPipe } from '@app/shared/pipes/filter.pipe';
import { ReplyBaccaratComponent } from '@app/shared/components/reply/reply-baccarat.component';
import { ModalAffiliateComponent } from '@app/shared/modals/affiliate-modal.component';
import { ReplyCrashComponent } from '@app/shared/components/reply/reply-crash.component';
import { ChartModule } from 'angular2-chartjs';
import { ReplySlotsComponent } from '@app/shared/components/reply/reply-slots.component';
import { FormModule } from '@app/shared/form/form.module';
import { CardFlipperDirective } from '@app/games/directives/card-flipper.directive';
import { FairnessResultModalComponent } from '@app/shared/modals/fairness-result-modal.component';
import { PageNotFoundComponent } from '@app/shared/components/page-not-found.component';
import { PanelBarComponent } from '@app/_v2/home/panel-bar/panel-bar.component';
import { PrivacypolicyModalComponent } from '@app/shared/modals/privacypolicy-modal.component';
import { SlotsWinBadgeComponent } from '@app/_v2/games/slots/components/win-badge.component';
import { ReplyRouletteComponent } from './components/reply/reply-roulette.component';
import { ModalChestForDepositComponent } from '@app/shared/modals/chest-for-deposit-modal.component';
import { ModalFreeSpinsComponent } from '@app/shared/modals/free-spins-modal.component';
import { ModalActiveBonusesComponent } from '@app/shared/modals/active-bonuses-modal.component';
import { PhoneBonusesModalComponent } from '@app/shared/modals/phone-bonuses-modal.component';
import { FooterComponent } from '@app/_v2/template/footer/footer.component';
import { HeroComponent } from '@app/_v2/template/hero/hero.component';
import { HeroNewComponent } from '@app/_v2/template/heroNew/heroNew.component';
import { contentComponents } from '@app/shared/content';
import { ReplyTreasureHuntComponent } from './components/reply/reply-treasure/reply-treasure-hunt.component';
import { TreasureReplyItemComponent } from '@app/shared/components/reply/reply-treasure/treasure-reply-item.component';
import { LegalComponentsModule } from '@app/_v2/legal/legal-components.module';
import { ReplyVideoPokerComponent } from './components/reply/reply-video-poker.component';
import { ReplyCryptoGemsComponent } from './components/reply/reply-crypto-gems/reply-crypto-gems.component';
import { AmountPipe } from '@app/shared/pipes/amount.pipe';
import { ReplyHiLoComponent } from '@app/shared/components/reply/reply-hi-lo/reply-hi-lo.component';
import { AutosizeDirective } from '@app/shared/directives/autosize.directive';
import { ReplyCasinoWarComponent } from '@app/shared/components/reply/reply-casino-war/reply-casino-war.component';
import { DepositPromotionModalComponent } from '@app/shared/modals/deposit-promotion-modal.component';
import { SelfieCaptureModalComponent } from '@app/shared/modals/selfie-capture-modal.component';
import { ReplyGreekSlotsComponent } from '@app/shared/components/reply/reply-greek-slots/reply-greek-slots.component';
import { CryptoPipe } from '@app/shared/pipes/crypto.pipe';
import { DefaultPipe } from '@app/shared/pipes/default.pipe';

@NgModule({
  imports: [
    CommonModule,
    // CoreModule,
    RouterModule,
    ReactiveFormsModule,
    TranslateModule,
    ClipboardModule,
    ChartModule,
    FormModule,
    LegalComponentsModule,
  ],
  exports: [
    LegalComponentsModule,
    AlertComponent,
    RouterModule,
    ClipboardModule,
    LoaderComponent,
    BtnLoaderComponent,
    FileUploaderComponent,
    BalanceIndicatorComponent,
    ReplyDiceComponent,
    ReplyBlackjackComponent,
    ReplyBaccaratComponent,
    ReplyCrashComponent,
    ReplySlotsComponent,
    ReplyCryptoGemsComponent,
    ReplyRouletteComponent,
    ReplyVideoPokerComponent,
    ReplyHiLoComponent,
    ReplyCasinoWarComponent,
    ReplyGreekSlotsComponent,
    UserAvatarComponent,
    InfiniteScrollDirective,
    AutosizeDirective,
    FilterPipe,
    AmountPipe,
    FormModule,
    CardFlipperDirective,
    PanelBarComponent,
    SlotsWinBadgeComponent,
    FooterComponent,
    HeroComponent,
    HeroNewComponent,
    ReplyTreasureHuntComponent,
    TreasureReplyItemComponent,
    ...contentComponents,
    CryptoPipe,
  ],
  declarations: [
    SelfieCaptureModalComponent,
    AlertComponent,
    LoaderComponent,
    BtnLoaderComponent,
    AlertModalComponent,
    FairnessModalComponent,
    FairnessResultModalComponent,
    TermsandconditionsModalComponent,
    PrivacypolicyModalComponent,
    FileUploaderComponent,
    BalanceIndicatorComponent,
    ReplyDiceComponent,
    ReplyBlackjackComponent,
    ReplyBaccaratComponent,
    ReplyCrashComponent,
    ReplySlotsComponent,
    ReplyCryptoGemsComponent,
    ReplyRouletteComponent,
    ReplyGreekSlotsComponent,
    GuestModalTimedComponent,
    UserAvatarComponent,
    InfiniteScrollDirective,
    AutosizeDirective,
    FilterPipe,
    AmountPipe,
    ModalAffiliateComponent,
    CardFlipperDirective,
    PageNotFoundComponent,
    PanelBarComponent,
    SlotsWinBadgeComponent,
    ModalChestForDepositComponent,
    ModalFreeSpinsComponent,
    ModalActiveBonusesComponent,
    PhoneBonusesModalComponent,
    FooterComponent,
    HeroComponent,
    HeroNewComponent,
    ReplyTreasureHuntComponent,
    ReplyVideoPokerComponent,
    ReplyHiLoComponent,
    ReplyCasinoWarComponent,
    TreasureReplyItemComponent,
    DepositPromotionModalComponent,
    ...contentComponents,
    CryptoPipe,
    DefaultPipe,
  ],
  providers: [ModalService, I18nService],
  entryComponents: [
    AlertComponent,
    AlertModalComponent,
    FairnessModalComponent,
    FairnessResultModalComponent,
    TermsandconditionsModalComponent,
    PrivacypolicyModalComponent,
    GuestModalTimedComponent,
    ModalAffiliateComponent,
    ModalChestForDepositComponent,
    ModalFreeSpinsComponent,
    ModalActiveBonusesComponent,
    PhoneBonusesModalComponent,
    DepositPromotionModalComponent,
    SelfieCaptureModalComponent,
  ],
})
export class SharedModule {}



// WEBPACK FOOTER //
// /var/lib/jenkins/workspace/Prod_web-client/src/app/shared/shared.module.ts